module.exports = __webpack_public_path__ + "img/sMayaQuest_350x350.c467f111.jpg";